import * as React from "react";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import { Button, Box } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { Link } from "react-router-dom";

export default function FarmerCard(props) {
  const {
    farmlandPhoto,
    farmerName,
    landExtent,
    expectedHarvest,
    address,
    openFarmerDetailsPopup,
    openCropsPopup,
  } = props;
  return (
    <Card sx={{ display: "flex" }}>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <CardMedia
          component="img"
          sx={{ width: 151 }}
          image={farmlandPhoto}
          alt=""
        />
        <CardContent sx={{ flex: "1 0 auto" }}>
          {/* <Typography component="div" variant="h5">
            Live From Space
          </Typography> */}
          <Typography variant="subtitle1" color="textSecondary" component="div">
            {farmerName}
          </Typography>
          <Typography variant="subtitle1" color="textSecondary" component="div">
            {address}
          </Typography>
          {/* <Typography variant="subtitle1" color="textSecondary" component="div">
            Land Extent: {landExtent} Acre
          </Typography>
          <Typography variant="subtitle1" color="textSecondary" component="div">
            Expected Harvest: {expectedHarvest} kg
          </Typography> */}
          <Button
            variant="text"
            size="small"
            color="primary"
            onClick={() => openFarmerDetailsPopup()}
          >
            Details
          </Button>
          <Button
            variant="text"
            size="small"
            color="primary"
            onClick={() => openCropsPopup()}
          >
            Crops
          </Button>
        </CardContent>
      </Box>
    </Card>
  );
}
